<template>
	<div>
		<div class="modal fade" id="CatModal" data-backdrop="static">
			<div class="modal-dialog" role="document">
				<!--
				=================================================================================================================
													CREATE TYPE OF EXAM MODAL!
				=================================================================================================================
			-->

				<div class="modal-content" style="width: 30%; margin: 0 auto">
					<div class="modal-header">
						<button
							type="button"
							class="close"
							data-dismiss="modal"
							aria-label="Close"
						>
							<span aria-hidden="true">&times;</span>
						</button>
						<h4 class="modal-title" id="myModalLabel">
							PRONTUARIO DE Tipos de Exame DOF
						</h4>
					</div>
					<!-- <div class="modal-body" v-if="!this.data.creationCPF"> -->
					<div class="modal-body">
						<div class="col-sm-12">
							<span>Nome</span>
							<input
								type="text"
								v-model="data.nome_tipo_exame"
								class="form-control"
								placeholder="NOME"
							/>
						</div>

						<div class="clearfix"></div>
						<br />
					</div>
					<div class="modal-footer">
						<div class="modal-footer__buttons">
							<button
								type="button"
								class="btn btn-default"
								data-dismiss="modal"
							>
								<i class="fa fa-close"></i> Cancelar
							</button>

							<aBtn
								action="private-save-tipos_de_exame"
								@click="save"
								text="Salvar"
								icon="save"
								type="primary"
							/>
						</div>
					</div>
				</div>
			</div>
		</div>
	</div>
</template>

<script>
	/*

	id precisa existir para poder ocorrer a criação

	*/
	import clone from 'js/clone';
	import aBox from 'box';
	import aBtn from 'btn';
	import WBS from 'js/http';
	import toastr from 'toastr';
	import axios from 'axios';
	import moment from 'moment';

	let reset = {
		nome_tipo_exame: '',
	};

	export default {
		name: 'ChModalTipos de Exame',
		components: { aBox, aBtn },
		data() {
			return {
				data: clone(reset),
				test: null,
				pessoas: [],
			};
		},
		methods: {
			open(data = null) {
				if (data != null) this.data = clone(data);
				else this.data = clone(reset);
				$('#CatModal').modal('show');
			},
			save() {
				WBS.send('private-save-tipos_de_exame', this.data, (resp) => {
					if (resp.status == 'success') {
						toastr.success('Registro alterado com sucesso!');
						this.$emit('update');
						$('#CatModal').modal('hide');
					} else {
						toastr.error(resp.msgs[0]);
						console.log(resp);
						console.log(this.data);
					}
				});
			},

			onSelectState() {
				axios
					.get(
						`https://servicodados.ibge.gov.br/api/v1/localidades/estados/${this.data.estado}/municipios?orderBy=nome`
					)
					.then((response) => (this.municipios = response.data));
			},
		},

		mounted() {
			axios
				.get(
					'https://servicodados.ibge.gov.br/api/v1/localidades/estados?orderBy=nome'
				)
				.then((response) => (this.estados = response.data));
		},
	};
</script>

<style>
	span {
		text-transform: uppercase;
	}

	.modal-dialog {
		width: 80% !important;
	}

	.modal-footer__buttons {
		display: flex;
		justify-content: space-between;
	}

	.add-more-section {
		display: flex;
	}
</style>



// WEBPACK FOOTER //
// src/components/cadastros/tipos_de_exame/modal.vue